import { JobStatus } from '@funnellab/shared/src/types/directus-enums';
import { SearchParamKeys } from '@funnellab/shared/src/types/SearchParamKeys';
import type { JobForWizard } from '@src/api/queries/job';
import type { WizardStep } from '@src/components/wizard/Wizard';

export const getSteps = async ({
  searchParams,
  paymentByInvoice,
  jobStatus,
}: {
  readonly searchParams: URLSearchParams;
  readonly paymentByInvoice: boolean;
  readonly jobStatus: `${JobStatus}`;
}): Promise<WizardStep<Partial<JobForWizard>>[]> => {
  const [
    { default: StepBenefits },
    { default: StepBillingAddress },
    { default: StepContacts },
    { default: StepEducation },
    { default: StepEmployerBrand },
    { default: StepFiles },
    { default: StepGeneral },
    { default: StepLocation },
    { default: StepOrganization },
    { default: StepPayment },
    { default: StepPriceCalculation },
    { default: StepSalary },
    { default: StepSkills },
    { default: StepSoftSkills },
    { default: StepTargetGroup },
    { default: StepTasks },
  ] = await Promise.all([
    import('@components/jobWizard/steps/StepBenefits'),
    import('@components/jobWizard/steps/StepBillingAddress'),
    import('@components/jobWizard/steps/StepContacts'),
    import('@components/jobWizard/steps/StepEducation'),
    import('@components/jobWizard/steps/StepEmployerBrand'),
    import('@components/jobWizard/steps/StepFiles'),
    import('@components/jobWizard/steps/StepGeneral'),
    import('@components/jobWizard/steps/StepLocation'),
    import('@components/jobWizard/steps/StepOrganization'),
    import('@components/jobWizard/steps/StepPayment'),
    import('@components/jobWizard/steps/StepPriceCalculation'),
    import('@components/jobWizard/steps/StepSalary'),
    import('@components/jobWizard/steps/StepSkills'),
    import('@components/jobWizard/steps/StepSoftSkills'),
    import('@components/jobWizard/steps/StepTargetGroup'),
    import('@components/jobWizard/steps/StepTasks'),
  ]);
  let steps: WizardStep<JobForWizard>[];
  if (jobStatus === JobStatus.REACTIVATING) {
    steps = [StepPriceCalculation, StepBillingAddress];
  } else {
    steps = [
      StepGeneral,
      StepEducation,
      StepSkills,
      StepLocation,
      StepTargetGroup,
      StepSoftSkills,
      StepTasks,
      StepOrganization,
      StepEmployerBrand,
      StepFiles,
      StepBenefits,
      StepSalary,
      StepContacts,
      StepPriceCalculation,
      StepBillingAddress,
    ];
    const orgId = searchParams.get(SearchParamKeys.ORG_ID);
    if (orgId) {
      steps = steps.filter((step) => step !== StepOrganization);
    }
  }
  if (!paymentByInvoice) {
    steps = [...steps, StepPayment];
  }

  return steps;
};
